module.exports = __webpack_public_path__ + "img/4.1f6fe062.jpg";